import React from "react";
import SectionTitle from "../../elements/section-title/SectionTitle";
import BlogListOne from "../../component/blog/BlogListOne";
import SectionTitle2 from "../../elements/section-title2/SectionTitle2";
import { Link } from "react-router-dom";

const BlogOne = () => {
  return (
    <div className="section section-padding-equal">
      <div className="container">
        <SectionTitle2
          subtitle="What's Going On"
          title="Latest blogs"
          description="Stay updated with the latest insights, tips, and expert advice on facility management."
          textAlignment=""
          textColor=""
        />
        <div className="row g-0">
          <BlogListOne colSize="col-xl-6" itemShow="2" />
        </div>
        <div className="news-update-link">
          <Link to={process.env.PUBLIC_URL + "/"}>View all blog→ </Link>
          {/* <Link to={process.env.PUBLIC_URL + "/contact"} className="axil-btn btn-fill-primary btn-large">News and Updates →</Link> */}
        </div>
      </div>
      {/* <ul className="shape-group-1 list-unstyled">
                <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"} alt="bubble" /></li>
                <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/line-1.png"} alt="bubble" /></li>
                <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/line-2.png"} alt="bubble" /></li>
                <li className="shape shape-4"><img src={process.env.PUBLIC_URL + "/images/others/bubble-2.png"} alt="bubble" /></li>
            </ul> */}
    </div>
  );
};

export default BlogOne;
